import classNames from 'classnames';
import { size, circle } from './Loader.css';

interface LoaderProps {
  size?: 'small' | 'xsmall' | 'medium' | 'large';
}

export const Loader: React.FC<LoaderProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={size[props.size || 'medium']}
      viewBox="0 0 300 134"
      aria-hidden
    >
      <circle cx="40" cy="67" r="40" fill="currentColor" className={classNames(circle)} />
      <circle cx="150" cy="67" r="40" fill="currentColor" className={classNames(circle)} />
      <circle cx="260" cy="67" r="40" fill="currentColor" className={classNames(circle)} />
    </svg>
  );
};
